import { defineComponent as o, createBlock as n, openBlock as r, unref as l, mergeProps as m, withCtx as i, createElementVNode as p } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconListViewChecks",
  __name: "IconListViewChecks",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (c, e) => (r(), n(l(s), m(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M8.53 4.57a.75.75 0 0 1 0 1.06L6.084 8.077a1.25 1.25 0 0 1-1.768 0L3.47 7.23a.75.75 0 0 1 1.06-1.06L5.2 6.84l2.27-2.27a.75.75 0 0 1 1.06 0m0 5.5a.75.75 0 0 1 0 1.06l-2.446 2.447a1.25 1.25 0 0 1-1.768 0L3.47 12.73a.75.75 0 0 1 1.06-1.06l.67.67 2.27-2.27a.75.75 0 0 1 1.06 0m0 5.5a.75.75 0 0 1 0 1.06l-2.446 2.447a1.25 1.25 0 0 1-1.768 0L3.47 18.23a.75.75 0 0 1 1.06-1.06l.67.67 2.27-2.27a.75.75 0 0 1 1.06 0m2.72-9.07A.75.75 0 0 1 12 5.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75m0 11A.75.75 0 0 1 12 16.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75m0-5.5A.75.75 0 0 1 12 11.25h8a.75.75 0 0 1 0 1.5h-8A.75.75 0 0 1 11.25 12",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
